var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticStyle: { "pointer-events": "auto" } },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: { icon: "", small: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.abrir.apply(null, arguments)
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_c("v-icon", [_vm._v("mdi-history")])],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v("Histórico do regime de trabalho")])]
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "760", scrollable: "" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "d-flex align-center" },
                [
                  _c("v-icon", { attrs: { left: "", color: "primary" } }, [
                    _vm._v("mdi-history"),
                  ]),
                  _c("div", [
                    _c("div", { staticClass: "text-h6" }, [
                      _vm._v("Histórico do regime de trabalho"),
                    ]),
                    _vm.teacherName
                      ? _c("div", { staticClass: "text-caption grey--text" }, [
                          _vm._v(_vm._s(_vm.teacherName)),
                        ])
                      : _vm._e(),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", disabled: _vm.loading },
                      on: { click: _vm.carregar },
                    },
                    [_c("v-icon", [_vm._v("mdi-refresh")])],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pt-4", staticStyle: { "min-height": "240px" } },
                [
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "text-center py-8" },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" },
                          }),
                        ],
                        1
                      )
                    : _vm.erro
                    ? _c(
                        "v-alert",
                        { attrs: { type: "error", dense: "", text: "" } },
                        [_vm._v(_vm._s(_vm.erro))]
                      )
                    : !_vm.historico.length
                    ? _c(
                        "v-alert",
                        { attrs: { type: "info", dense: "", text: "" } },
                        [
                          _vm._v(
                            " Ainda não há alterações registradas para o regime de trabalho deste professor. "
                          ),
                        ]
                      )
                    : _c(
                        "v-timeline",
                        { attrs: { dense: "", "align-top": "" } },
                        _vm._l(_vm.historico, function (item) {
                          return _c(
                            "v-timeline-item",
                            {
                              key: item.id,
                              attrs: {
                                color: item.regime_changed
                                  ? "primary"
                                  : "grey lighten-1",
                                small: "",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-wrap align-center mb-1",
                                },
                                [
                                  _c("strong", { staticClass: "mr-3" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateTime")(item.created_at)
                                      )
                                    ),
                                  ]),
                                  item.work_time
                                    ? _c(
                                        "v-chip",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            "x-small": "",
                                            outlined: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Período " + _vm._s(item.work_time)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "span",
                                    { staticClass: "text-caption grey--text" },
                                    [_vm._v(_vm._s(item.performed_by))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "mb-2" },
                                [
                                  item.regime_changed
                                    ? [
                                        _c("v-chip", { attrs: { small: "" } }, [
                                          _vm._v(
                                            _vm._s(
                                              item.regime_before || "Sem regime"
                                            )
                                          ),
                                        ]),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mx-1",
                                            attrs: { small: "" },
                                          },
                                          [_vm._v("mdi-arrow-right")]
                                        ),
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              small: "",
                                              color: "primary",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.regime_after ||
                                                  "Sem regime"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "span",
                                          { staticClass: "text-body-2" },
                                          [_vm._v("Regime mantido:")]
                                        ),
                                        _c(
                                          "v-chip",
                                          {
                                            staticClass: "ml-1",
                                            attrs: { small: "" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.regime_after ||
                                                  "Sem regime"
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              ),
                              item.details_after
                                ? _c(
                                    "v-simple-table",
                                    {
                                      staticClass: "regime-history__table",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c("thead", [
                                        _c("tr", [
                                          _c("th", [
                                            _vm._v("Carga horária semanal"),
                                          ]),
                                          item.details_before
                                            ? _c("th", [_vm._v("Antes")])
                                            : _vm._e(),
                                          _c("th", [_vm._v("Depois")]),
                                        ]),
                                      ]),
                                      _c(
                                        "tbody",
                                        _vm._l(_vm.linhas, function (linha) {
                                          return _c(
                                            "tr",
                                            { key: linha.campo },
                                            [
                                              _c("td", [
                                                _vm._v(_vm._s(linha.rotulo)),
                                              ]),
                                              item.details_before
                                                ? _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatar(
                                                          item.details_before[
                                                            linha.campo
                                                          ],
                                                          linha.unidade
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _c(
                                                "td",
                                                {
                                                  class: {
                                                    "font-weight-bold":
                                                      _vm.mudou(
                                                        item,
                                                        linha.campo
                                                      ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatar(
                                                        item.details_after[
                                                          linha.campo
                                                        ],
                                                        linha.unidade
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }